// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-selectable-article {
  margin: 0 auto;
  flex-grow: 1;
  word-break: break-word;
  background: white;
  border: 0.5px solid #939393;
  border-radius: 5px;
  transition: border 200ms linear;
  width: 165px;
  height: 250px;
  display: flex;
  flex-direction: column;
}

.card-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 8px;
}

.option-price {
  font-size: 14px;
  margin: 8px auto 12px;
  font-weight: 600;
  color: black;
  text-align: center;
}

.name {
  margin-top: 8px;
  font-size: 14px;
  width: 100%;
  font-weight: 500;
  text-align: center;
  padding: 0 8px;
  line-height: 1.3;
  min-height: 36px;
  max-height: 36px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.select-button {
  margin-top: auto;
  padding: 9.5px 7.92px 7.92px 7.92px;
  background: #F1EFEA;
  font-size: 14px;
  font-weight: 400;
  font-family: AppFont;
  color: #1D1D1B;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 141px;
  height: 39px;
}
.select-button:hover {
  background: #ebebeb;
}
.select-button:active {
  background: #e0e0e0;
}

.item-selectable-article-image {
  margin: 0 auto;
  height: 100px;
}

app-quantity-selector {
  filter: drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.1));
}

.quantity-row {
  bottom: 0;
  right: 0;
  left: 0;
  justify-content: center;
  --quantity-selector-border-width: 1.5px;
  --quantity-selector-height: 24px;
}

.selected-icon {
  width: 24px;
  height: 24px;
  position: absolute;
  top: 0;
  left: -3px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/item-selectable-article/item-selectable-article.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,2BAAA;EACA,kBAAA;EACA,+BAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;AACF;;AAEA;EACE,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,gBAAA;EACA,mCAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;AACF;AACE;EACE,mBAAA;AACJ;AAEE;EACE,mBAAA;AAAJ;;AAIA;EACE,cAAA;EACA,aAAA;AADF;;AAIA;EACE,oDAAA;AADF;;AAIA;EACE,SAAA;EACA,QAAA;EACA,OAAA;EACA,uBAAA;EACA,uCAAA;EACA,gCAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;AADF","sourcesContent":[".item-selectable-article {\n  margin: 0 auto;\n  flex-grow: 1;\n  word-break: break-word;\n  background: white;\n  border: 0.5px solid #939393;\n  border-radius: 5px;\n  transition: border 200ms linear;\n  width: 165px;\n  height: 250px;\n  display: flex;\n  flex-direction: column;\n}\n\n.card-content {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  padding: 8px;\n}\n\n.option-price {\n  font-size: 14px;\n  margin: 8px auto 12px;\n  font-weight: 600;\n  color: black;\n  text-align: center;\n}\n\n.name {\n  margin-top: 8px;\n  font-size: 14px;\n  width: 100%;\n  font-weight: 500;\n  text-align: center;\n  padding: 0 8px;\n  line-height: 1.3;\n  min-height: 36px;\n  max-height: 36px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.select-button {\n  margin-top: auto;\n  padding: 9.5px 7.92px 7.92px 7.92px;\n  background: #F1EFEA;\n  font-size: 14px;\n  font-weight: 400;\n  font-family: AppFont;\n  color: #1D1D1B;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: 141px;\n  height: 39px;\n\n  &:hover {\n    background: #ebebeb;\n  }\n\n  &:active {\n    background: #e0e0e0;\n  }\n}\n\n.item-selectable-article-image {\n  margin: 0 auto;\n  height: 100px;\n}\n\napp-quantity-selector {\n  filter: drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.1));\n}\n\n.quantity-row {\n  bottom: 0;\n  right: 0;\n  left: 0;\n  justify-content: center;\n  --quantity-selector-border-width: 1.5px;\n  --quantity-selector-height: 24px;\n}\n\n.selected-icon {\n  width: 24px;\n  height: 24px;\n  position: absolute;\n  top: 0;\n  left: -3px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
